import React, { useState } from 'react';
import {
  Box,
  Paper,
  TextField,
  IconButton,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { useTranslation } from 'react-i18next';

function MessageInput({ onSendMessage, inputRef }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [messageText, setMessageText] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (messageText.trim() === '') return;

    onSendMessage(messageText);
    setMessageText('');
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <Box
      ref={inputRef}
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: 'flex',
        p: isMobile ? 1 : 1.5,
        gap: isMobile ? 0.5 : 1,
        alignItems: 'center',
        flexShrink: 0,
        bgcolor: theme.palette.background.paper,
      }}
    >
      <Paper
        elevation={0}
        variant="outlined"
        sx={{
          display: 'flex',
          alignItems: 'center',
          p: isMobile ? 0.75 : 1,
          borderRadius: isMobile ? 3 : 5,
          width: '100%',
        }}
      >
        <TextField
          fullWidth
          multiline
          maxRows={isMobile ? 3 : 4}
          placeholder={t('chatWindow.messagePlaceholder')}
          value={messageText}
          onChange={(e) => setMessageText(e.target.value)}
          onKeyDown={handleKeyPress}
          variant="standard"
          slotProps={{ input: { disableUnderline: true } }}
          sx={{
            '& .MuiInputBase-input': {
              fontSize: isMobile ? '0.875rem' : '1rem',
              padding: isMobile ? '4px 0' : '8px 0',
            },
          }}
        />
        <IconButton
          type="submit"
          color="primary"
          disabled={messageText.trim() === ''}
          sx={{
            bgcolor: 'primary.main',
            color: 'white',
            '&:hover': {
              bgcolor: 'primary.dark',
            },
            '&.Mui-disabled': {
              bgcolor:
                theme.palette.mode === 'dark'
                  ? 'rgba(255,255,255,0.1)'
                  : 'rgba(0,0,0,0.1)',
              color:
                theme.palette.mode === 'dark'
                  ? 'rgba(255,255,255,0.3)'
                  : 'rgba(0,0,0,0.3)',
            },
            width: isMobile ? 36 : 40,
            height: isMobile ? 36 : 40,
          }}
        >
          <SendIcon fontSize={isMobile ? 'small' : 'medium'} />
        </IconButton>
      </Paper>
    </Box>
  );
}

export default MessageInput;
